export default "__VITE_ASSET__CSsUEOgC__"